import Album from "../components/album";
import React from "react";

export function SearchView() {
    return (
        <Album/>
    )
}